<div class="mx-auto border-t">
  <footer
    class="p-4 bg-white rounded-lg shadow md:px-6 md:py-8"
  >
    <div class="sm:flex sm:items-center sm:justify-between">
      <img
        src="assets/img/pulse-color.png"
        class="mr-4 h-8"
        width="50"
        height="100"
        alt="MSLA B2B Logo"
      />
      <ul class="flex flex-wrap items-center mb-6 sm:mb-0">
        <li>
          <a
            href="https://pulse-latam.com/"
            target='_blank'
            class="mr-4 text-sm text-gray-500 hover:underline md:mr-6"
            >About us</a
          >
        </li>
        <!--<li>
          <a
            href="#"
            class="mr-4 text-sm text-gray-500 hover:underline md:mr-6"
            >Privacy Policy</a
          >
        </li>
        <li>
          <a
            href="#"
            class="text-sm text-gray-500 hover:underline"
            >Contact</a
          >
        </li>-->
      </ul>
    </div>
    <hr class="my-6 border-gray-200 sm:mx-auto lg:my-8" />
    <span class="block text-sm text-gray-500 sm:text-center"
      >© 2022
      <a href="https://flowbite.com" target="_blank" class="hover:underline"
        >MSLA International B2B Data Platform</a
      >. All Rights Reserved.
    </span>
  </footer>
</div>
